(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tap-chi-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      const grid = root.querySelector("[data-tapchi-grid]");
      const select = root.querySelector("[data-tapchi-sort]");
      if (!grid || !select) return;

      const reorder = (mode) => {
        const items = Array.from(grid.querySelectorAll("[data-tapchi-item]"));
        items
          .sort((a, b) => {
            const da = Number(a.dataset.date) || 0;
            const db = Number(b.dataset.date) || 0;
            return mode === "oldest" ? da - db : db - da;
          })
          .forEach((item) => grid.appendChild(item));
      };

      select.addEventListener("change", () => reorder(select.value));
    };

    document.querySelectorAll("[data-tapchi-list]").forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
